import { Component, OnInit, ViewChild, ViewChildren, HostListener, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';

@Component({
  selector: 'darkadia-news-carousel',
  templateUrl: './news-carousel.component.html',
  providers: [NewsCarouselComponent]  // add NgbCarouselConfig to the component providers
})
export class NewsCarouselComponent implements OnInit {
  lastNewsList: Array<{ id: number, title: string, summary: string, image: string, link: string, publishedDate: string }>;
  newsCarouselHeight: number;
  newsCarouselWidth: number;
  newsWidth: number;
  carouselPos: number;
  incno: number;

  @ViewChild('carouselContainer') parentDiv: ElementRef;
  @ViewChild('innerCarousel') innerCarousel: ElementRef;
  @ViewChild('leftArrow') leftArrow: ElementRef;
  @ViewChild('rightArrow') rightArrow: ElementRef;
  @ViewChild('carouselDiv') carouselDiv: ElementRef;
  @ViewChildren('newsItem') newsItems: Array<ElementRef>;

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    this.newsCarouselHeight = window.screen.height;
    this.newsCarouselWidth = window.screen.width;
  }
  
  @HostListener('window:resize') onResize() {
    // guard against resize before view is rendered
    if (this.parentDiv) {
      this.newsCarouselWidth = this.parentDiv.nativeElement.clientWidth;
      this.newsCarouselHeight = this.parentDiv.nativeElement.clientHeight;
      this.resizeNewsCard();
    }
  }

  ngAfterViewInit() {
    // wait a tick to avoid one-time devMode
    // unidirectional-data-flow-violation error
    setTimeout(_ => {
      this.newsCarouselWidth = this.parentDiv.nativeElement.clientWidth;
      this.newsCarouselHeight = this.parentDiv.nativeElement.clientHeight;
      this.resizeNewsCard();
    });
  }

  resizeNewsCard() {
    var itemClass = ('.item');
    let itemsSplit: Array<number>;
    let id: number;
    this.carouselPos = 0;
    
    itemsSplit = this.carouselDiv.nativeElement.attributes['data-items'].value.split(',');
    if (this.newsCarouselWidth >= 1200) {
      this.incno = itemsSplit[3];
      this.newsWidth = this.newsCarouselWidth / this.incno;
    }
    else if (this.newsCarouselWidth >= 992) {
      this.incno = (itemsSplit[2]);
      this.newsWidth = this.newsCarouselWidth / this.incno;
    }
    else if (this.newsCarouselWidth >= 768) {
      this.incno = (itemsSplit[1]);
      this.newsWidth = this.newsCarouselWidth / this.incno;
    } else {
      this.incno = (itemsSplit[0]);
      this.newsWidth = this.newsCarouselWidth / this.incno;
    }
    this.newsWidth -=10;
    this.newsItems.forEach(function (newsItem) {
      id = id + 1;
      this.renderer.setStyle(
        newsItem.nativeElement,
        'width',
        this.newsWidth+'px'
      );

    }.bind(this));
    this.renderer.setStyle(
      this.innerCarousel.nativeElement,
      'width',
      (this.newsWidth+10)*this.lastNewsList.length + 'px',
    );
    this.transformCarousel();
  }

  ngOnInit() {
    this.lastNewsList = [];
    this.loadNews();
    this.initCarousel();
  }

  loadNews(){
  }

  initCarousel() {
    this.lastNewsList.push({ 
      id: 1, 
      title: "News 1", 
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 2,
      title: "News 2",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 3,
      title: "News 3",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 4,
      title: "News 4",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 5,
      title: "News 5",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 6,
      title: "News 6",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 7,
      title: "News 7",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 8,
      title: "News 8",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 9,
      title: "News 9",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
    this.lastNewsList.push({
      id: 10,
      title: "News 10",
      summary: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam quis ipsum urna. Maecenas sit amet leo dignissim, vestibulum justo a ...",
      image: "http://via.placeholder.com/300x150",
      link:"#", publishedDate:"01/01/2018"
    });
  }

  nextNews(){
    this.carouselPos -= this.newsWidth;
    this.transformCarousel();
  }

  lastNews() {
    this.carouselPos += this.newsWidth;
    this.transformCarousel();
  }

  transformCarousel(){
    let xRight = this.incno*this.newsWidth;
    let fullWidth = this.lastNewsList.length * this.newsWidth;
    let carouselPosRight = this.carouselPos+fullWidth;

    this.renderer.removeClass(this.leftArrow.nativeElement, 'over');
    this.renderer.removeClass(this.rightArrow.nativeElement, 'over');

    if(this.carouselPos>=0){
      this.carouselPos=0;
      this.renderer.addClass(this.leftArrow.nativeElement, 'over');
    }
    if (carouselPosRight<=xRight){
      //this.carouselPos = 0;//-(this.lastNewsList.length * this.newsWidth);
      this.renderer.addClass(this.rightArrow.nativeElement, 'over');
    }
    this.renderer.setStyle(
      this.innerCarousel.nativeElement,
      'transform',
      'translateX(' + this.carouselPos + 'px)',
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/components/news-carousel/news-carousel.component.ts